import { CheckableGroupComponent } from "./chunk-74SYDCTI.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/RadioGroup/RadioGroup.tsx
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var RadioGroup = _a => {
  var _b = _a,
    {
      children,
      className
    } = _b,
    rest = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */jsx(CheckableGroupComponent, __spreadProps(__spreadValues({
    className: clsx("pd:radio-group", className)
  }, rest), {
    children: /* @__PURE__ */jsx(CheckableGroupComponent.Fields, {
      className: "pd:radio-group__fields",
      children
    })
  }));
};
var RadioGroup_default = RadioGroup;
export { RadioGroup_default };